import React from "react";
import { connect } from "react-redux";
import Image from "../../components/Image";
import Container from "../../components/Container";
import { trackClick } from "../../services/analytics/actions";
import logo from "./logo-outro.svg";
import "./style.css";

const Footer = ({ trackClick }) => (
  <div className="footer">
    <Container>
      <p>
        Hoeveel je stem werkelijk waard is, hangt dus af van de opkomst. Wat
        weer bepalend is voor de kiesdeler: het totaal aantal stemmen dat nodig
        is om 1 zetel in de gemeenteraad te bemachtigen. Hoe meer mensen er
        stemmen, hoe groter de kiesdeler.
      </p>
      <p>
        Deel welke opkomst jij verwacht en stuur je vrienden een reminder om te
        stemmen.
      </p>

      <div className="footer__social">
        <a
          rel="noopener noreferrer"
          target="_blank"
          onClick={() => trackClick("footer", "facebook")}
          href="https://www.facebook.com/sharer/sharer.php?u=https%3A//app.nos.nl/grv2018/index.html"
          className="btn"
        >
          Facebook
        </a>
        <a
          rel="noopener noreferrer"
          target="_blank"
          onClick={() => trackClick("footer", "twitter")}
          href={`https://twitter.com/home?status=Ze%20zijn%20met%20minder%20en%20ze%20stemmen%20minder%3A%20zoveel%20(of%20weinig)%20invloed%20hebben%20jongeren%20in%20jouw%20gemeente+https%3A//app.nos.nl/grv2018/index.html`}
          className="btn"
        >
          Twitter
        </a>
      </div>
    </Container>
    <Image slim src={logo} className="footer__logo" />
  </div>
);

export default connect(null, { trackClick })(Footer);



// WEBPACK FOOTER //
// ./src/scenes/Footer/index.js